var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNightShelter = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.125L17.5 8.75V20H2.5V8.75L10 3.125ZM10 0L0 7.5V22.5H20V7.5L10 0ZM13.75 11.25H9.375V15.625H5V10H3.75V18.75H5V16.875H15V18.75H16.25V13.75C16.25 12.375 15.125 11.25 13.75 11.25ZM7.1875 11.875C6.325 11.875 5.625 12.575 5.625 13.4375C5.625 14.3 6.325 15 7.1875 15C8.05 15 8.75 14.3 8.75 13.4375C8.75 12.575 8.05 11.875 7.1875 11.875Z",
    fill: "#2F2F2F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNightShelter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/night_shelter.10def6e8.svg";
export { ForwardRef as ReactComponent };